import { EMAIL_TEMPLATE_TYPES } from '../../../core/email/template/subjects';

/**
 * Convert camelCase type to SEO-friendly kebab-case slug.
 * e.g. welcomeEmail -> welcome-email
 */
export function typeToSlug(type) {
  if (!type || typeof type !== 'string') return '';
  return type
    .replace(/([A-Z])/g, '-$1')
    .toLowerCase()
    .replace(/^-/, '');
}

const slugToTypeMap = (() => {
  const map = {};
  EMAIL_TEMPLATE_TYPES.forEach((t) => {
    map[typeToSlug(t)] = t;
  });
  return map;
})();

/**
 * Resolve URL slug back to internal type.
 * Supports both SEO slug (welcome-email) and legacy type (welcomeEmail).
 */
export function slugToType(slug) {
  if (!slug || typeof slug !== 'string') return null;
  const normalized = slug.trim();
  if (slugToTypeMap[normalized]) return slugToTypeMap[normalized];
  if (EMAIL_TEMPLATE_TYPES.includes(normalized)) return normalized;
  return null;
}
